import httpClient from './httpClient';
import { API_ENDPOINTS, ApiResponse } from './api';
import { SchedulePlan, SchedulePlanFormData } from 'pages/app/YearlyCalendar/utils/types';

export const yearlyCalendarEndpoints = {
  SCHEDULE_PLAN: {
    LIST: '/yearly-calendar/schedule-plans',
    DETAIL: (id: string) => `/yearly-calendar/schedule-plans/${id}`,
    CREATE: '/yearly-calendar/schedule-plans',
    UPDATE: '/yearly-calendar/schedule-plans',
    DELETE: '/yearly-calendar/schedule-plans',
    GET_MODULES: '/yearly-calendar/modules',
    GET_TARGET_POSITIONS: '/yearly-calendar/target-positions',
    GET_TRAINING_PROVIDERS: '/yearly-calendar/training-providers'
  }
};

const ENDPOINTS = {
  ...API_ENDPOINTS,
  YEARLY_CALENDAR: yearlyCalendarEndpoints
};

export const yearlyCalendarService = {
  getSchedulePlans: async (params?: { search?: string; page?: number; limit?: number }) => {
    try {
      const response = await httpClient.get<ApiResponse<SchedulePlan>>(
        ENDPOINTS.YEARLY_CALENDAR.SCHEDULE_PLAN.LIST,
        {
          params: {
            pageNumber: params?.page || 1,
            pageSize: params?.limit || 10,
            search: params?.search || ''
          }
        }
      );

      if (!Array.isArray(response.data.data)) {
        response.data.data = [];
      }

      return response.data;
    } catch {
      return {
        pageNumber: params?.page || 1,
        pageSize: params?.limit || 10,
        totalPages: 0,
        totalRecords: 0,
        message: 'Failed to fetch schedule plans',
        data: []
      };
    }
  },

  getSchedulePlanDetail: async (id: string) => {
    try {
      const response = await httpClient.get(ENDPOINTS.YEARLY_CALENDAR.SCHEDULE_PLAN.DETAIL(id));
      return response.data;
    } catch {
      throw new Error('Failed to fetch schedule plan detail');
    }
  },

  createSchedulePlan: async (data: SchedulePlanFormData) => {
    try {
      const response = await httpClient.post(ENDPOINTS.YEARLY_CALENDAR.SCHEDULE_PLAN.CREATE, data);
      return response.data;
    } catch {
      throw new Error('Failed to create schedule plan');
    }
  },

  updateSchedulePlan: async (id: string, data: SchedulePlanFormData) => {
    try {
      const response = await httpClient.put(
        `${ENDPOINTS.YEARLY_CALENDAR.SCHEDULE_PLAN.UPDATE}/${id}`,
        data
      );
      return response.data;
    } catch {
      throw new Error('Failed to update schedule plan');
    }
  },

  deleteSchedulePlan: async (id: string) => {
    try {
      const response = await httpClient.delete(
        `${ENDPOINTS.YEARLY_CALENDAR.SCHEDULE_PLAN.DELETE}/${id}`
      );
      return response.data;
    } catch {
      throw new Error('Failed to delete schedule plan');
    }
  },

  getModules: async () => {
    try {
      const response = await httpClient.get(ENDPOINTS.YEARLY_CALENDAR.SCHEDULE_PLAN.GET_MODULES);
      return response.data;
    } catch {
      throw new Error('Failed to fetch modules');
    }
  },

  getTargetPositions: async () => {
    try {
      const response = await httpClient.get(
        ENDPOINTS.YEARLY_CALENDAR.SCHEDULE_PLAN.GET_TARGET_POSITIONS
      );
      return response.data;
    } catch {
      throw new Error('Failed to fetch target positions');
    }
  },

  getTrainingProviders: async () => {
    try {
      const response = await httpClient.get(
        ENDPOINTS.YEARLY_CALENDAR.SCHEDULE_PLAN.GET_TRAINING_PROVIDERS
      );
      return response.data;
    } catch {
      throw new Error('Failed to fetch training providers');
    }
  }
};

export default yearlyCalendarService;
